<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="actionEditor">
        <h2 mat-dialog-title>{{Copy.getTitle()}}</h2>
        <mat-dialog-content class="flex-grow-1" *ngIf="Copy">
            <div style="margin: auto; width: 120px;" *ngIf="isLoadingArticles; else settingsSimplified">
                <mat-spinner></mat-spinner>
            </div>
            <ng-template #settingsSimplified>
                <div class="row" *ngFor="let block of Copy.Blocks">
                    <div class="col-sm-12">
                        <h2 mat-dialog-title>{{block.getTitle()}}
                          <br>
                          <mat-icon [class.text-danger]="getBlockInValid(block)" class="text-success">{{getBlockInValid(block) ? 'remove_circle' : 'check_circle'}}</mat-icon>
                          {{block.StepRequired ? (getBlockSelected(block) + '/' + (block.MaxRequired ? block.MaxRequired : (getHighestBlockStep() * block.StepRequired))) : ''}}
                          {{!block.StepRequired ? (getBlockSelected(block) + '/' + ((!block.MinRequired && this.Copy.Operator === 'and' ? '1' : block.MinRequired) + '-' + block.MaxRequired)) : ''}}
                        </h2>
                        <div class="row">
                            <div class="col-sm-3" *ngFor="let option of block.Options"
                                 style="background-color: rgba(91, 202, 202, 0.05); text-align: center">
                                <div *ngIf="getArticleImage(option)" class="imageBox" [ngStyle]="{'background-image': 'url('+ (option.Image ? option.getImage() : getArticleImage(option))+')'}">
                                </div>
                                <p *ngFor="let line of option.BasketLines">
                                  {{line.Ordered}}x {{line.Article?.CommercialName}}
                                  {{line.UnitPrice ? '(' + Relation?.PriceList?.Currency?.FreeTextField1 : ''}} {{line.UnitPrice ? (line.UnitPrice * (1 - line.Discount)) + ' | - ' + (line.Discount * 100) +
                                  '%)' : ''}} <br>
                                </p>
                                <div style="text-align: center">
                                    <button mat-icon-button type="button" color="primary"
                                            [disabled]="(!!option.MinRequired && option.MinRequired >= getOptionSelected(option)) || (!!block.MinRequired && block.MinRequired >= getBlockSelected(block)) || getOptionSelected(option) === 0"
                                            (click)="removeOption(option)">
                                        <mat-icon>remove_circle</mat-icon>
                                    </button>
                                    {{getCount(option)}}
                                    <button mat-icon-button type="button" color="primary"
                                            [disabled]="(!!option.MaxRequired && option.MaxRequired <= getOptionSelected(option)) || (!!block.MaxRequired && block.MaxRequired <= getBlockSelected(block))"
                                            (click)="addOption(option)">
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </mat-dialog-content>
        <mat-dialog-actions class="d-flex">
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close i18n>Close</button>
            <app-button [disabled]="checkValid()" [isLoading]="isLoading" i18n-title title="Add to shopping cart"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
